/** Articles this browser has read to the end (localStorage), for the learning-path progress bars. */
import { createStore, useStore } from '../../../lib/store';

const KEY = 'academy.read.v1';

function load(): string[] {
  try {
    const v: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(v) ? v.filter((s): s is string => typeof s === 'string') : [];
  } catch {
    return [];
  }
}

const store = createStore<{ read: readonly string[] }>({ read: load() });

export function markRead(slug: string) {
  const read = store.get().read;
  if (read.includes(slug)) return;
  const next = [...read, slug];
  store.set({ read: next });
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable: progress lasts for this visit only */
  }
}

export function useReadSet(): ReadonlySet<string> {
  const read = useStore(store, (s) => s.read);
  return new Set(read);
}
